import { render } from "./messenger.vue?vue&type=template&id=29826ad0"
import script from "./messenger.vue?vue&type=script&lang=js"
export * from "./messenger.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__